import { useSyncExternalStore } from 'react';

import { useDeviceHeader } from '@packages/shared/src/providers/DeviceHeaderProvider/useDeviceHeader';

// TODO: move the breakpoint to a shared constants file, from where this hook and also the theme will use it
// keep in sync with the `lg` breakpoint of the theme, which swaps the navigation variants
const DESKTOP_NAVIGATION_QUERY = '(min-width: 900px)';

const getClientSnapshot = (): boolean => {
  if (typeof window === 'undefined') return true;

  // Use matchMedia.matches - no layout reflow like innerWidth
  return window.matchMedia(DESKTOP_NAVIGATION_QUERY).matches;
};

const subscribe = (callback: () => void) => {
  if (typeof window === 'undefined') return () => {};

  const controller = new AbortController();

  const desktopQuery = window.matchMedia(DESKTOP_NAVIGATION_QUERY);
  desktopQuery.addEventListener('change', callback, { signal: controller.signal });

  return () => controller.abort();
};

/**
 * Tells whether the desktop navigation bar is rendered instead of the hamburger menu, which the
 * `lg` breakpoint decides.
 *
 * Resolved from the device header while rendering on the server and from the viewport after
 * hydration, so navigation data and behaviour stay in sync with the rendered navigation even when
 * the device header does not match the viewport.
 *
 * @returns boolean - true for the desktop navigation bar, false for the hamburger menu
 */
export const useIsDesktopNavigation = (): boolean => {
  const deviceFromHeaders = useDeviceHeader();

  // Server snapshot based on device type - returns true for desktop
  const getServerSnapshot = () => deviceFromHeaders === 'desktop';

  return useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
};
